import { Component, OnInit } from '@angular/core';
import { AdvancedFilter } from '@kodit/core/shared-ui';
import {
  IGetArhivskaKnjigaTableQuery,
  IKategorijaDokMaterijalaDto,
} from '@kodit/core/data-api';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { Store } from '@ngrx/store';
import {
  clearFilter,
  setFilter,
} from '../../../../../../shared-subforms/src/lib/racun/state/filters/filter.actions';
import { ARHIVSKA_KNJIGA_FILTER_KEY } from '../arhivska-knjiga-table.component';
import { FormControl } from '@angular/forms';
import { FormHelper } from '@kodit/core/form-definitions';

@Component({
  selector: 'kodit-arhivska-knjiga-filter',
  templateUrl: './arhivska-knjiga-filter.component.html',
  styleUrls: ['./arhivska-knjiga-filter.component.scss'],
})
export class ArhivskaKnjigaFilterComponent
  implements OnInit, AdvancedFilter<IGetArhivskaKnjigaTableQuery> {
  /** Props */
  filterData!: IGetArhivskaKnjigaTableQuery;
  availableFilters?: {};
  form!: FormGroupTypeSafe<IGetArhivskaKnjigaTableQuery>;
  sadrzajModel: IKategorijaDokMaterijalaDto | undefined;

  constructor(
    private _storage: Store,
    private _fb: FormBuilderTypeSafe,
    private _formHelper: FormHelper
  ) {}

  ngOnInit(): void {
    this._initForm(this.filterData);
    this.sadrzajModel = {
      naziv: this.form.value.sadrzaj,
    } as IKategorijaDokMaterijalaDto;
  }

  onFilterSubmit() {
    this._storage.dispatch(
      setFilter({
        key: ARHIVSKA_KNJIGA_FILTER_KEY,
        filter: JSON.stringify(this.form.value),
      })
    );
  }

  onFilterHide(shouldReset: boolean) {
    if (shouldReset) {
      this._storage.dispatch(
        clearFilter({
          key: ARHIVSKA_KNJIGA_FILTER_KEY,
        })
      );
    }
  }

  handleSadrzajChanged(value: IKategorijaDokMaterijalaDto) {
    this.form.controls.sadrzaj!.patchValue(value.naziv);
    this.sadrzajModel = value;
  }

  private _initForm(model?: IGetArhivskaKnjigaTableQuery) {
    this.form = this._fb.group<IGetArhivskaKnjigaTableQuery>({
      datumUpisaOd: this._formHelper.initializeDateFormControl(
        model?.datumUpisaOd!
      ),
      datumUpisaDo: this._formHelper.initializeDateFormControl(
        model?.datumUpisaDo!
      ),
      godinaNastanka: new FormControl(model?.godinaNastanka),
      sadrzaj: new FormControl(model?.sadrzaj),
    });
  }
}
